import { savingsOverview } from './overview-config/HU';
import { savingsSettingsDetails } from './settings-config/HU';

export const savings = {
    settingsDetails: savingsSettingsDetails,
    overview: savingsOverview,
};
